<template>
    <div>
        <div class="boost-container flex flex-col items-center space-y-6 p-6">
            <h2 class="text-center text-3xl font-semibold text-white font-bold">Boost your links today</h2>
            <a href="#form" ><button class="rounded-full text-xl hover:bg-blue-200 p-3 bg-blue-500 text-center mx-auto">Get Started</button></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Boost',
    }
</script>

<style scoped>
    .boost-container{
        height: 100%;
        width: 100%;
        background-color: hsl(257, 27%, 26%);
        background-image: url(../assets/images/bg-boost-desktop.svg);
    }
</style>